import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import arLang from "./ar/translation.json";
import enLang from "./en/translation.json";

const resources = {
  en: { translation: enLang },
  ar: { translation: arLang },
};

i18n.use(initReactI18next).init({
  resources,
  interpolation: {
    escapeValue: false,
  },
  fallbackLng: "en",
});

export default i18n;
